import { render, staticRenderFns } from "./planosBimestraisInterdisciplinar.vue?vue&type=template&id=e733a522"
import script from "./planosBimestraisInterdisciplinar.vue?vue&type=script&lang=js"
export * from "./planosBimestraisInterdisciplinar.vue?vue&type=script&lang=js"
import style0 from "./planosBimestraisInterdisciplinar.vue?vue&type=style&index=0&id=e733a522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports